<template lang="html">

  <Modal 
    :title="pageTitle"
    :type="'tray'"
    :withCloseButton="true"
    :applyWarningColors="applyWarningColors"
    @close="close"
  class="scroll-smooth overflow-y-auto bgcolor">
   <div class="m-2">
    <a
      href="/"
      tabIndex="1"    
      class="cursor-pointer back-button bg-black py-2 px-4 rounded inline-flex items-center bg-black font-sans font-bold w-32 pt-2 pb-2 tracking-wider hover:text-yellow-300 hover:font-bold border-4 rounded-md text-lg"
    >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
         <span>BACK</span>
    </a>
    </div>
  <!-- <Modal
    :title="pageTitle"
    :type="'tray'"
    :withCloseButton="true"
    :applyWarningColors="applyWarningColors"
    @close="close"
  > -->
    <form class="settings-form" ref="form">
      <h1 class="h1">Preferences</h1>
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Play sounds</legend>
        <ul class="settings-list">
          <SettingItem
            :label="'When the timer ends'"
            :type="'checkbox'"
            :setting="settingPlayTimerCompleteSound"
            @update="updateSettingPlayTimerCompleteSound"
          />
          <SettingItem
            :label="'At each of the 10 last seconds'"
            :type="'checkbox'"
            :setting="settingPlayTimerCountdownSound"
            @update="updateSettingPlayTimerCountdownSound"
          />
        </ul>
      </fieldset>
      <!-- <fieldset class="fieldset">
        <legend class="fieldset-legend">When time is almost up</legend>
        <ul class="settings-list">
          <SettingItem
            :label="'Make the background yellow'"
            :type="'checkbox'"
            :setting="settingWarnWhenTimeIsAlmostUp"
            @update="updateSettingWarnWhenTimeIsAlmostUp"
          />
        </ul>
      </fieldset> -->
      <fieldset class="fieldset">
        <legend class="fieldset-legend">When time is up</legend>
        <ul class="settings-list">
          <SettingItem
            :label="'Count up'"
            :type="'checkbox'"
            :setting="settingContinueBeyondZero"
            :showComment="settingRepeat && settingContinueBeyondZero"
            :comment="'The Repeat option is enabled. Disable it on the main screen to make the timer count up after reaching 0:00.'"
            @update="updateSettingContinueBeyondZero"
          />
          <SettingItem
            :label="'Show notifications'"
            :type="'checkbox'"
            :setting="settingShowNotifications"
            :comment="'Show a notification when the timer ends in an inactive browser tab.'"
            @update="updateSettingShowNotifications"
          />
        </ul>
      </fieldset>
      <!-- <fieldset class="fieldset">
        <legend class="fieldset-legend">Transitions & animations</legend>
        <ul class="settings-list">
          <SettingItem
            :label="'Reduce motion'"
            :type="'checkbox'"
            :setting="settingReducedMotion"
            @update="updateSettingReducedMotion"
          />
        </ul>
      </fieldset> -->
    </form>
    <!-- </div> -->
  <!-- </Modal> -->
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import SettingItem from "./SettingItem.vue";

export default {
  name: "PreferencesMenu",

  components: {
    Modal,
    SettingItem,
  },

  props: {
    settingRepeat: {
      // Boolean, but is allowed to be undefined
      required: true,
    },
    settingPlayTimerCompleteSound: {
      type: Boolean,
      required: true,
    },
    settingPlayTimerCountdownSound: {
      type: Boolean,
      required: true,
    },
    settingWarnWhenTimeIsAlmostUp: {
      type: Boolean,
      required: true,
    },
    settingContinueBeyondZero: {
      type: Boolean,
      required: true,
    },
    settingReducedMotion: {
      required: true,
    },
    settingShowNotifications: {
      required: true,
    },
    browserSupportsPermissionsAPI: {
      type: Boolean,
      required: true,
    },
    applyWarningColors: {
      required: true,
      type: Boolean,
    },
  },

  data() {
    return {
      pageTitle: "Preferences",
    };
  },

  head: {
    title: function () {
      return {
        inner: this.pageTitle,
      };
    },
    link: function () {
      return [
        {
          rel: "canonical",
          href: "https://www.bigtimer.net" + this.$route.path,
          id: "canonical",
        },
      ];
    },
  },

  mounted() {
    this.$emit("update:visibleTray", this.componentName);
  },

  beforeDestroy() {
    this.$emit("update:visibleTray", "");
  },

  methods: {
    updateSettingPlayTimerCompleteSound(newVal) {
      this.$emit("update:settingPlayTimerCompleteSound", newVal);
    },
    updateSettingPlayTimerCountdownSound(newVal) {
      this.$emit("update:settingPlayTimerCountdownSound", newVal);
    },
    updateSettingWarnWhenTimeIsAlmostUp(newVal) {
      this.$emit("update:settingWarnWhenTimeIsAlmostUp", newVal);
    },
    updateSettingContinueBeyondZero(newVal) {
      this.$emit("update:settingContinueBeyondZero", newVal);
    },
    updateSettingReducedMotion(newVal) {
      newVal = true;
      this.$emit("update:settingReducedMotion", newVal);
    },
    updateSettingShowNotifications(newVal) {
      this.$emit("update:settingShowNotifications", newVal);
    },
    close() {
      this.$router.push({ name: "home" });
    },
  },

  computed: {
    componentName() {
      if (!this.$vnode) {
        return "[unknown]";
      } else if (this.$vnode.tag) {
        let name = this.$vnode.tag;
        return name.replace(/vue-component-\d+-/i, "");
      } else if (vm.$el.id) {
        return vm.$el.id;
      }
    },
  },

  watch: {
    visible(newVal) {
      this.$refs.form.focus();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../style/abstracts/variables.scss";
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";

.bgcolor {
  background: #fc0;
}

.back-button {
  color: #fc0;
  border-color: #000;
  border-block-color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/PreferencesMenu.vue